import api from "../../../service/api";
import ActionTypes from "../../actionTypes";
import API_BOOK from "../../../service/endpoints";

const { GET_ALL_DATA_SUCCESS, GET_ALL_DATA_FAIL } = ActionTypes.REPORTS.KM_DAILY;
const { GET_KM_DAILY } = API_BOOK.REPORTS.KM_REPORT;

/* Action dispatchers */

const getAllKmDailySuccessAD = (payload) => ({
  type: GET_ALL_DATA_SUCCESS,
  payload,
});

const getAllKmDailyFailAD = () => ({
  type: GET_ALL_DATA_FAIL,
});

/* Actions */

/**
 *  @desc         Get KM Daily data
 *  @api          /reports/km-daily
 *  @method       POST
 **/
export const GetKmDaily = ({ registrationNumbers, fromDate, toDate, pageSize, pageIndex }) => async (dispatch) => {
  try {
    const resp = await api({
      method: GET_KM_DAILY.method,
      url: GET_KM_DAILY.url,
      data: {
        registrationNumbers: registrationNumbers?.map((val) => val.label),
        fromDate,
        toDate,
        pageSize,
        pageIndex,
      }
    });

    if (resp.status === 200 && resp?.data?.data) {
      const response = resp?.data?.data;
      dispatch(getAllKmDailySuccessAD(response));
    } else {
      dispatch(getAllKmDailyFailAD());
    }
  } catch (error) {
    dispatch(getAllKmDailyFailAD());
    console.log("error:", error);
  }
};
